import api from '../../utils/api'

export const state = {
  importsEmailsPlanRelease: [],
  importEmailsPlanReleaseMeta: {}
}

export const mutations = {
  SET_IMPORTS_EMAILS_PLAN_RELEASE(state, importsEmailsPlanRelease) {
    state.importsEmailsPlanRelease = importsEmailsPlanRelease
  },
  SET_IMPORTS_EMAILS_PLAN_RELEASE_META(state, importEmailsPlanReleaseMeta) {
    state.importEmailsPlanReleaseMeta = importEmailsPlanReleaseMeta
  }
}

export const actions = {
  async handleCreate(_, body) {
    try {
      return await api.post('/import-emails-plan-release', body)
    } catch (err) {
      throw err
    }
  },

  async handlePagedList({ commit }, payload) {
    try {
      let params = {}

      if (payload) {
        params = {
          page: payload.page || 1,
          limit: payload.limit || 10
        }
      }
      commit('SET_IMPORTS_EMAILS_PLAN_RELEASE', [])
      commit('SET_IMPORTS_EMAILS_PLAN_RELEASE_META', {})
      const { data: response } = await api.get('/import-emails-plan-release', { params })
      commit('SET_IMPORTS_EMAILS_PLAN_RELEASE', response.items)
      commit('SET_IMPORTS_EMAILS_PLAN_RELEASE_META', response.meta)
    } catch (err) {
      throw err
    }
  },

  async handleGetImportEmailsPlanReleaseLog(_, { importEmailsPlanReleaseId, type, page, limit, search }) {
    try {
      const params = {
        type,
        page: page || 1,
        limit: limit || 15,
        ...(search && { search })
      }
      return await api.get(`/import-emails-plan-release/${importEmailsPlanReleaseId}/log`, { params })
    } catch (err) {
      throw err
    }
  },

  async handleGetImportEmailsPlanReleaseConversion(_, importEmailsPlanReleaseId) {
    try {
      return await api.get(`/import-emails-plan-release/${importEmailsPlanReleaseId}/conversion`)
    } catch (err) {
      throw err
    }
  },

  async handleGetImportEmailsPlanRelease(_, _id) {
    try {
      return await api.get(`/import-emails-plan-release/${_id}`)
    } catch (err) {
      throw err
    }
  }


}

export const getters = {
  importsEmailsPlanRelease: (state) => state.importsEmailsPlanRelease,
  importEmailsPlanReleaseMeta: (state) => state.importEmailsPlanReleaseMeta
}
